"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createCurrentCardiologicalState = createCurrentCardiologicalState;
const shared_1 = require("../../shared");
const createEkg_1 = require("./createEkg");
const createHeartFailureMedicalTherapy_1 = require("./createHeartFailureMedicalTherapy");
const messages = {
    currentCardiologicalState: {
        id: "dashboard.current_cardiological_state",
        defaultMessage: "Aktuális kardiológiai állapot"
    }
};
function createCurrentCardiologicalState(intl, options) {
    const ekg = (0, createEkg_1.createEkg)(intl, options);
    const heartFailueMedicalTherapy = (0, createHeartFailureMedicalTherapy_1.createHeartFailueMedicalTherapy)(intl, options);
    const content = (0, shared_1.createSectionContent)([ekg, heartFailueMedicalTherapy]);
    return (0, shared_1.createSection)(intl, {
        label: messages.currentCardiologicalState,
        content
    });
}
